<template>
  <div class="panel panel-stretch panel-default">
    <div class="panel-heading">
      Adressen van {{ firstName }}
    </div>
    <div class="panel-body">
      <div v-for="(customerProperties, key) in customerPropertiesGroupedByType"
           class="card" style="margin-bottom: 15px;">
        <table class="table table-striped table-bordered table-responsive">
          <thead class="flex-row">
          <tr>
            <th class="col-xs-6">
              <i v-if="key === 'mail'" class="mdi mdi-mail"></i>
              <i v-else-if="key === 'unknown'" class="mdi mdi-comment-question"></i>
              <i v-else class="mdi mdi-home"></i>
              {{ translateKey(key) }}
            </th>
            <th class="col-xs-4"></th>
            <th class="col-xs-2"></th>
          </tr>
          </thead>
          <tbody v-if="hasCustomerProperties(customerProperties)">
          <CustomerPropertyRowComponent v-for="customerProperty in customerProperties"
                                        v-bind:key="customerProperty.id"
                                        :customer-property-id="customerProperty.id"/>
          </tbody>
        </table>
        <span v-if="!hasCustomerProperties(customerProperties)">
          <span>Er zijn geen adressen van dit type.</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerPropertyRowComponent from './RowComponent'
import CustomerBadgeComponent from "../../customer/components/BadgeComponent";
import customerPropertyApi from "~/api/customer_property";

export default {
  name: "CustomerPropertyIndexPanelComponent",
  components: {
    CustomerPropertyRowComponent,
    CustomerBadgeComponent
  },
  props: {
    customer: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      customerProperties: [],
      selectedCustomerProperties: {},
      addressTypes: {
        'visit': 'Bezoekadressen',
        'mail': 'Postadressen',
        'establishment': 'Vestiginsadressen',
        'unknown': ' Onbekende adrestypes'
      },
    };
  },
  computed: {
    selectedCustomerPropertiesExists() {
      return this.selectedCustomerProperties !== null;
    },
    customerPropertiesGroupedByType() {
      return this.customerProperties.reduce((accumulator, customerProperty) => {
        if (typeof accumulator[customerProperty.address_type] === "undefined") {
          accumulator[customerProperty.address_type] = [];
        }

        accumulator[customerProperty.address_type].push(customerProperty);

        return accumulator;
      }, {});
    },
    firstName() {
      return this.customer.first_name || this.customer.firstName;
    }
  },
  mounted() {
    customerPropertyApi.paginateByCustomer(this.customer.id, 1, 100).then(response => {
      this.customerProperties = response.data;
    });
  },
  methods: {
    changeSelectedCustomerProperties(selectedMemberId) {
      this.selectedCustomerProperties = this.customerProperties[selectedMemberId]

    },
    familyMemberSelected(key) {
      this.selectedFamilyMemberId = key
      this.changeSelectedCustomerProperties(key)
    },
    customerShortName(customer) {
      let shortName = '';

      if (customer.initials !== null && customer.initials.length > 0) {
        shortName += customer.initials;
      } else if (customer.first_name) {
        shortName += customer.first_name;
      } else {
        shortName += customer.firstName;
      }

      if (customer.suffix !== null && customer.suffix.length > 0) {
        shortName += ' ' + customer.suffix;
      }

      if (customer.last_name) {
        shortName += ' ' + customer.last_name;
      } else {
        shortName += ' ' + customer.lastName;

      }

      //TODO:: add age

      return shortName;
    },
    hasCustomerProperties(customerProperties) {
      return customerProperties.length > 0;
    },

    translateKey(key) {
      return this.addressTypes[key]
    },
    handleToCreate() {
      window.location = '/customer/' + this.selectedFamilyMemberId + '/property/create';
    },
    getCustomerAvatarUrl(customer) {
      return '/customer/' + customer.id + '/avatar'
    }
  }
}
</script>
<style scoped>

.avatar {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin-top: -2px;
}
</style>
